'use client';

import { useEffect, useState } from 'react';

export const useIsHydrated = () => {
  // Using useState will cause a rerender of component depending on this
  const [isHydrated, setIsHydrated] = useState(false);
  useEffect(() => {
    setIsHydrated(true);
  }, []);
  return isHydrated;
};
